module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Mavericus: "), _c('br'), _vm._v("Mission Unspecified")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#chapter-1-a-return-to-earth"
    }
  }, [_vm._v("Chapter 1: A Return to Earth")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#chapter-2-a-strained-reunion"
    }
  }, [_vm._v("Chapter 2: A Strained Reunion")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#chapter-3-a-father-and-a-son"
    }
  }, [_vm._v("Chapter 3: A Father and a Son")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-4-an-unexpected-mission"
    }
  }, [_vm._v("Chapter 4: An Unexpected Mission")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#chapter-5-the-mavericus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Mavericus")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-6-the-feud-and-unexpected-passengers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: The Feud and Unexpected Passengers")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-7-the-drills-begin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Drills Begin")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-8-the-mission-revealed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The Mission Revealed")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-9-the-trigger-mans-burden",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Trigger Man’s Burden")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-10-the-hyrolvia-crisis-unfolds",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: The Hyrolvia Crisis Unfolds")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-11-voyaging-onto-the-next-mission",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Voyaging onto the Next Mission")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-12-a-devastating-feud",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: A Devastating Feud")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-13-the-captains-gamble",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: The Captain’s Gamble")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-14-the-tunnels-of-ice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: The Tunnels of Ice")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-15-first-contact-with-new-enemies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: First Contact with New Enemies")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-16-threats-aboard-the-mavericus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Threats Aboard the Mavericus")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-17-suspect-bad-luck-or-bad-history",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Suspect, Bad Luck, or Bad History")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-18-the-quiet-outpost",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: The Quiet Outpost")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-19-going-back-for-old-friends",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Going Back for Old Friends")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-20-loose-lightning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Loose Lightning")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-21-pirates-aboard-the-mavericus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Pirates Aboard the Mavericus")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-22-to-the-unknown-and-beyond",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: To the Unknown and Beyond")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0